import type {BaseFilterKeys} from '@igp/shared/api';
import type {MultiKeyFilterTextValue} from '@igp/shared/components/filter';
import type {DebtResponsibleMasterAgent, DebtResponsibleMasterAgentsPage, Timestamp} from '@igp/shared/contract/pam';
import type {Path} from '@igp/shared/utils';

export const DebtResponsibleMasterAgentsServiceTypes = {
    service: Symbol('DebtResponsibleMasterAgentsService'),
    downloadClientStrategy: Symbol('DebtResponsibleMasterAgentsDownloadClientStrategy'),
    downloadServerStrategy: Symbol('DebtResponsibleMasterAgentsDownloadServerStrategy'),
    epicsBuilder: Symbol('DebtResponsibleMasterAgentEpicsBuilder'),
} as const;

export type DebtResponsibleMasterAgentQueryFields = Path<DebtResponsibleMasterAgentsPage>;

export type DebtResponsibleMasterAgentDownloadFields = Path<DebtResponsibleMasterAgent>;

export type DebtResponsibleMasterAgentQueryFilterKeys = BaseFilterKeys | 'agent_uid';

export type DebtResponsibleMasterAgentTextFilterKeys = 'agent_uid';

export type DebtResponsibleMasterAgentFilterName = 'agentUid';

export type DebtResponsibleMasterAgentFilterViewModel = {
    text: MultiKeyFilterTextValue<DebtResponsibleMasterAgentTextFilterKeys>;
};

export type DebtResponsibleMasterAgentViewModel = {
    agent_uid: string;
    aggregated_downline_debt?: number;
    created_at?: Timestamp;
    created_by?: string;
    downline_agents_count?: number;
    username?: string;
};

export type DebtResponsibleMasterAgentViewModelKeys = keyof DebtResponsibleMasterAgentViewModel;

export type DebtResponsibleMasterAgentDownloadModel = Record<DebtResponsibleMasterAgentViewModelKeys, string>;

export type DebtResponsibleMasterAgentSortKeys = keyof Omit<DebtResponsibleMasterAgent, '__typename'>;

export type AddDebtResponsibleMasterPayload = {
    agent_id: string;
};

export type RemoveDebtResponsibleMasterPayload = {
    agent_id: string;
};
